export const UHC_BACKFILL_JOB_TYPE = 'uhc_835_backfill';

function parseDate(value) {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(value || '') || value.startsWith('0000')) {
    throw new Error('Both document search dates are required and must be valid dates.');
  }
  const date = new Date(`${value}T00:00:00Z`);
  if (!Number.isFinite(date.getTime()) || date.toISOString().slice(0, 10) !== value) {
    throw new Error('Enter valid document search dates.');
  }
  return date;
}

export function buildUhcBackfillParams({ siteId, fromDate, toDate }, now = new Date()) {
  const site = String(siteId || '').trim();
  if (!/^[1-9]\d*$/.test(site) || !Number.isSafeInteger(Number(site))) {
    throw new Error('Site ID must be a positive whole number.');
  }
  const start = parseDate(fromDate);
  const end = parseDate(toDate);
  const days = (end - start) / 86400000 + 1;
  if (days < 1 || days > 366) {
    throw new Error('Use an inclusive date range of at most 366 days, with the end on or after the start.');
  }
  if (toDate >= now.toISOString().slice(0, 10)) {
    throw new Error('The end date must be before today (UTC).');
  }
  const format = value => {
    const [year, month, day] = value.split('-');
    return `${month}/${day}/${year}`;
  };
  // Construct an allowlist rather than spreading shared portal form state.
  return { site_id: Number(site), from_date: format(fromDate), to_date: format(toDate) };
}

export function uhcBackfillError(values, now) {
  try { buildUhcBackfillParams(values, now); return ''; } catch (error) { return error.message; }
}

export function uhcCreateError(detail) {
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) {
    const messages = detail.map(item => item?.msg).filter(message => typeof message === 'string');
    if (messages.length) return messages.join(' ');
  }
  return 'Failed to create UHC backfill. Check the site and dates, then try again.';
}
